<template>
  <Select
    v-model="selectedValue"
    :placeholder="placeholder"
    :filterable="isFilterable"
    :multiple="isMultiple"
    :loading="isLoading"
    @on-change="handleOnChange"
    @on-create="handleOnCreate"
    @on-select="handleOnSelect"
    @on-clear="handleOnSelect"
    :class="classes"
    clearable
    :allow-create="allowCreate"
    :disabled="disabled"
    transfer>
    <Option v-for="item in optionList" :value="item.value" :key="item.value" :disabled="item.disabled">{{ item.label }}</Option>
  </Select>
</template>

<script>
export default {
  props: {
    classes: {
      type: String,
      default: ''
    },
    // size: {
    //   type: String,
    //   default: ''
    // },
    placeholder: {
      type: String,
      default: 'Select'
    },
    value: {
      type: [String, Array, Number],
      default: ''
    },
    optionList: {
      type: Array,
      default: () => []
    },
    isFilterable: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    isMultiple: {
      type: Boolean,
      default: false
    },
    allowCreate: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    selectedValue: {
      get: function () {
        return this.value
      },
      set: function (newValue) {
        this.$emit('input', newValue)
      }
    }
  },
  methods: {
    handleOnChange (val) {
      this.$emit('input', val)
    },
    handleOnSelect (val) {
      this.$emit('select', (val) ? val.value : null)
    },
    handleOnCreate (val) {
      this.optionList.push({
        value: val,
        label: val
      })
    }
  }
}
</script>

<style>
.afc-select {
text-align: left;
}
</style>
